function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}

export { _pipe as default };
